export default __webpack_public_path__ + "static/media/fintech-icon-03.331bac55.svg";